<template>
	<div>
        <!-- personal card start -->
        <div class="card">
            <div class="card-header">
                <h5 class="card-header-text">About</h5>
            </div>
            <div class="card-block">
                <div class="view-info">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="general-info">
                                <div class="row">
                                    <div class="col-lg-12 col-xl-6">
                                        <div class="table-responsive">
                                            <table class="table m-0">
                                                <tbody>
                                                    <tr>
                                                        <th scope="row">Full Name</th>
                                                        <td>{{$parent.applicant.firstname + " " + $parent.applicant.lastname}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Age</th>
                                                        <td>{{$parent.applicant.age}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Phone</th>
                                                        <td>{{$parent.applicant.phonenumber}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Email ID</th>
                                                        <td><a v-bind:href="'mailto:' + $parent.applicant.emailaddress">{{$parent.applicant.emailaddress}}</a></td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Course</th>
                                                        <td>{{$parent.applicant.course}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Qualification</th>
                                                        <td>{{$parent.applicant.education}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <!-- end of table col-lg-6 -->
                                    <div class="col-lg-12 col-xl-6">
                                        <div class="table-responsive">
                                            <table class="table m-0">
                                                <tbody>
                                                    <tr>
                                                        <th scope="row">Grade</th>
                                                        <td>{{$parent.applicant.grades}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Current or Immediate Past Employer</th>
                                                        <td>{{$parent.applicant.current_employer}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">LinkedIn</th>
                                                        <td><a href="">{{$parent.applicant.linkedinprofile}}</a></td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Referrer</th>
                                                        <td>{{$parent.applicant.referrer}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Referrer Name</th>
                                                        <td>{{$parent.applicant.referrer_name}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <!-- end of table col-lg-6 -->
                                </div>
                                <!-- end of row -->
                            </div>
                            <!-- end of general info -->
                        </div>
                        <!-- end of col-lg-12 -->
                    </div>
                    <!-- end of row -->
                </div>
            </div>
            <!-- end of card-block -->
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header">
                        <h5 class="card-header-text">Cover Letter</h5>
                    </div>
                    <div class="card-block user-desc">
                        <div class="view-desc">
                            <div v-html="$parent.applicant.cover_letter"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- personal card end-->
    </div>
</template>

<script type="text/javascript">
	export default{
		name: 'About'
	}
</script>